import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotification } from './components/PurchaseNotification';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { ProblemAgitation } from './components/ProblemAgitation';
import { TargetAudience } from './components/TargetAudience';
import { SystemOverview } from './components/SystemOverview';
import { ContentPhase } from './components/ContentPhase';
import { Bonuses } from './components/Bonuses';
import { ComparisonTable } from './components/ComparisonTable';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-bone selection:bg-oxblood selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <Testimonials data-id="element-3" />
      <ProblemAgitation data-id="element-4" />
      <TargetAudience data-id="element-5" />
      <SystemOverview data-id="element-6" />
      <ContentPhase data-id="element-7" />
      <Bonuses data-id="element-8" />
      <ComparisonTable data-id="element-9" />
      <FinalCta data-id="element-10" />
      <Footer data-id="element-11" />
      <PurchaseNotification data-id="element-12" />
    </main>;
}